/**
 * Creates registration settings for use in react form hooks register method.
 * @returns {{}}
 */
export const createRegistrationSettings = (label, defaultValue, validation, customValidation) => {
  let settings = {};

  /**
   * Set required validation.
   */
  if (validation?.IsRequired) {
    settings.required = {
      value: validation.IsRequired,
      message: validation.ValidationMsg
    };
  }

  /**
   * Set length validation.
   */
  if (validation?.Length) {
    settings.maxLength = {
      value: validation.Length,
      message: `${label} cannot exceed ${validation.Length} characters`
    };
  }

  /**
   * Set default value.
   */
  if (defaultValue) {
    settings.value = defaultValue;
  }

  /**
   * Set custom validation.
   */
  if (customValidation) {
    settings = {
      ...settings,
      ...customValidation
    };
  }

  return settings;
};
